import React from 'react'
import './styles.scss';

const defaultPortalPath = "https://getpocket.com/explore/";

export default ({portalPath = defaultPortalPath, copywriteYear = 2019 }) => (
    <section className="story-page">
        <footer className="story-footer-container">
            <div className="grid-container-structure">
                <div className="column middle grid-container-content">
                    <ul className="story-footer">
                        <li><a href="/?src=explore_footer">Get Pocket</a></li>
                        <li><a href={`${portalPath}must-reads?src=explore_footer`}>Pocket Worthy</a></li>
                        <li><a href={`${portalPath}?src=explore_footer`}>Pocket Hits</a></li>
                        <li><a href="/sponsor">Advertise with Pocket</a></li>
                        <li><a href="/tos">Terms of Service</a></li>
                        <li><a href="/privacy">Privacy Policy</a></li>
                        <li>&copy; Read It Later, Inc {copywriteYear}</li>
                        <li className="social-icons">
                            <a href="http://facebook.com/pocket" target="_blank" alt="Pocket Facebook">
                                {/*TODO: Refactor w image-mask, as done in PersistentActions component*/}
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M17.0062 0H0.99375C0.44475 0 0 0.44475 0 0.99375V17.007C0 17.5553 0.44475 18 0.99375 18H9.615V11.0295H7.269V8.313H9.615V6.30975C9.615 3.98475 11.0347 2.71875 13.1093 2.71875C14.103 2.71875 14.9565 2.793 15.2055 2.826V5.256L13.767 5.25675C12.639 5.25675 12.4208 5.793 12.4208 6.579V8.31375H15.111L14.7607 11.0302H12.4208V18H17.0077C17.5553 18 18 17.5553 18 17.0062V0.99375C18 0.44475 17.5553 0 17.0062 0V0Z"
                                        fill="#919191"/>
                                </svg>
                            </a>
                            <a href="http://twitter.com/pocket" target="_blank" alt="Pocket Twitter">
                                <svg fill="none" height="16" viewBox="0 0 20 16" width="20"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path clipRule="evenodd"
                                          d="m19.1666 2.27688c-.6742.30288-1.3992.50227-2.16.59566.7767-.46694 1.3692-1.20983 1.6542-2.092379-.7225.432439-1.5325.748779-2.3875.918729-.6875-.737843-1.665-1.19889-2.7467-1.19889-2.0792 0-3.76335 1.69695-3.76335 3.78933 0 .29699.0375.58641.09917.86152-3.12833-.15649-5.89917-1.66583-7.75333-3.95507-.32667.55864-.51334 1.20982-.51334 1.90055 0 1.31499.6675 2.47266 1.67834 3.15245-.62167-.02019-1.20084-.19266-1.7075-.47114v.04375c0 1.83577 1.29583 3.36782 3.01916 3.71024-.3175.09171-.64916.1363-.99333.1363-.23917 0-.47667-.02356-.705-.06563.47583 1.5051 1.86417 2.5972 3.51167 2.6283-1.28917 1.0146-2.90917 1.6221-4.66917 1.6221-.30333 0-.60333-.0211-.896668-.0539 1.662498 1.0736 3.639998 1.7012 5.761668 1.7012 6.92248 0 10.70588-5.76813 10.70588-10.77318 0-.1649-.0059-.32812-.0117-.49217.7358-.53509 1.3742-1.20142 1.8775-1.95777z"
                                          fill="#919191" fillRule="evenodd"/>
                                </svg>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </footer>
    </section>
);
